export * from './LegalCertificateIcon'
